import { render, staticRenderFns } from "./Chat.vue?vue&type=template&id=91d63dac&lang=pug&"
import script from "./Chat.ts?vue&type=script&lang=js&"
export * from "./Chat.ts?vue&type=script&lang=js&"
import style0 from "./Chat.sass?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports